var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"mx-auto",attrs:{"id":"google-signin"}}),(_vm.error)?_c('div',{staticClass:"py-2 error--text small-text"},[_vm._v(" "+_vm._s(_vm.$t('errors.email_not_validated'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }